export default __webpack_public_path__ + "static/media/26.dff7a82b.png";